import call, { json } from './call';

// The hook endpoints (CONTEXT.md "Hook").
export const listHooks = (token, { courseId } = {}) => call(
    `/api/hooks${courseId ? `?course_id=${courseId}` : ''}`, token, { method: 'GET' },
).then(data => data.items || []);

export const createHook = (token, courseId, payload) => call(`/api/courses/${courseId}/hooks`, token, json('POST', payload));
export const updateHook = (token, id, payload) => call(`/api/hooks/${id}`, token, json('PUT', payload));
export const deleteHook = (token, id) => call(`/api/hooks/${id}`, token, { method: 'DELETE' });
export const approveHook = (token, id) => call(`/api/hooks/${id}/approve`, token, { method: 'POST' });
export const revokeHook = (token, id) => call(`/api/hooks/${id}/approve`, token, { method: 'DELETE' });
export const draftHook = (token, courseId) => call(`/api/courses/${courseId}/draft-hook`, token, { method: 'POST' }).then(data => data.hook);
// Up to `max` proposals on different facts (the server returns fewer when the content is thin).
export const draftHooks = (token, courseId, max) => call(`/api/courses/${courseId}/draft-hook?max=${max}`, token, { method: 'POST' }).then(data => data.hooks || []);
export const reorderHooks = (token, courseId, hookIds) => call(
    `/api/courses/${courseId}/hooks/order`, token, json('PUT', { hook_ids: hookIds }),
).then(data => data.items || []);
